module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_10000-d65c9992432cb3be96ab95fd4f13084b.png";